import api from 'ApiConfig';

const headhrStudentService = {
  getStudentOverview: async (batchId) => {
    return api.post('/headhr/get-practicle-assignment-overview', { batchId });
  },

  getMcqTestOverview: async (batchId) => {
    return api.post('/headhr/get-mcq-test-overview', { batchId });
  },

  getQaTestOverview: async (batchId) => {
    return api.post('/headhr/get-qa-test-overview', { batchId });
  },

  getMCQAssignmentOverview: async (batchId) => {
    return api.post('/headhr/get-mcq-assignment-overview', { batchId });
  },

  getQAAssignmentOverview: async (batchId) => {
    return api.post('/headhr/get-qa-assignment-overview', { batchId });
  },

  getStudentWiseOverview: async (courseId, batchId) => {
    return api.post('/headhr/student-wise-placement-overview', {
      courseId,
      batchId,
    });
  },

  searchStudentsForPlacement: async (search, selectedBranch) => {
    return api.post('/headhr/search-student-for-placement', {
      search,
      selectedBranch,
    });
  },
  getAllStudentforPlacement: async (courseId, batchId, selectedBranch) => {
    return api.post('/headhr/get-all-student-for-placement', {
      courseId,
      batchId,
      selectedBranch,
    });
  },

  makeReadyForPlacement: async (payload) => {
    return api.post('/headhr/mark-student-placement-ready', payload);
  },
  getExternalMockOverview: async (batchId) => {
    return api.post('/headhr/get-external-mock-overview', { batchId });
  },
  getExternalPracticeOverview: async (batchId) => {
    return api.post('/headhr/get-external-practice-overview', { batchId });
  },

  searchStudents: async (searchTerm, selectedBranch) => {
    return api.post('/headhr/search-students', { searchTerm, selectedBranch });
  },

  approveUnpausePlacement: async (notificationId, approve, adminReason) => {
    return api.post('/headhr/approve-unpause-placement-req', {
      notificationId,
      approve,
      adminReason,
    });
  },

  unpausePlacement: async (studentId, unpauseReason) => {
    return api.post('/headhr/unpause-placement', { studentId, unpauseReason });
  },
};

export default headhrStudentService;
